export const STIPULATIONS_REQUEST_PENDING = 'stipulations_request_pending';
export const STIPULATIONS_REQUEST_RECEIVED = 'stipulations_request_received';
export const STIPULATIONS_REQUEST_ERROR = 'stipulations_request_error';
